export const navLinks = [
	{ name: 'home', path: '/' },
	{ name: 'mechanism', path: 'https://docs.chainparty.xyz/chain-party/what-is-chain-party' },
	{ name: 'game', path: '/game' }
];
